import { Divider } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import React, { Component } from "react";
import DownloadWhite from "../../assets/img/downloadIcon.svg";
import navbarsStyle from "../../assets/jss/material-kit-pro-react/views/componentsSections/navbarsStyle";
import Button from "../Material/CustomButtons/Button";
import CustomDropdown from "../Material/CustomDropdown/CustomDropdown";
import { GetGHGEstimationUrl } from "../../config";
import axios from "axios";
import { decodeOpAccessToken } from "../../utility";
import { Lock } from "@material-ui/icons";
import { showLockUpPopup } from "../../UI/Popups/lockUpPopUp";

class BulkUploadBtnDownloadTemplateDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activities: [],
    };
  }
  async componentDidMount() {
    try {
      const decodedToken = decodeOpAccessToken(localStorage.opsToken);
      if(!decodedToken) return;
      
      const opConfig = {
        headers: {
          "x-sk-op-authorization": localStorage.opsToken,
          "Content-Type": "application/json",
        },
      };

      const organizationId =
        decodedToken["https://hasura.io/jwt/claims"]["x-hasura-org-id"];

      const buyerSupplierRoleResponse = await axios.post(
        GetGHGEstimationUrl() + "api/v1/users/buyer-supplier-role",
        { organizationId: organizationId },
        opConfig
      );

      const formData = {
        organizationId: organizationId,
        userId:
          decodedToken["https://hasura.io/jwt/claims"]["x-hasura-user-id"],
      };

      const response = await axios.post(
        GetGHGEstimationUrl() + "api/v1/users/activity-permissions",
        formData,
        opConfig
      );
      const activities = response.data.data
        .filter((item) => item.locations && item.locations.length > 0)
        .map((item) => ({
          activity: item.label,
          activityHeader: item.label,
          activity_code: item.sub_activity,
          section: item.main_activity,
          downloadLink: item.template_link,
          locations: item.locations,
        }));

      const allActivitiesData = response.data.allActivities
      .filter((item) => !(item.code === "buyer_share" && buyerSupplierRoleResponse && buyerSupplierRoleResponse.data && buyerSupplierRoleResponse.data.data === "BUYER"))
      .map((item) => {
        const isExist = activities.filter((act) => act.activity_code === item.code)
        if (isExist && isExist.length > 0) {
          return {
            ...item,
            ...isExist[0],
          }
        } 
        return {
          ...item,
          ...{ activity:  item.name },
          ...{activityHeader:  item.name},
          isLocked : true
        } 
      });

      // Sort activities based on isLocked status, if isLocked is false then show them first and alphabetically
      allActivitiesData.sort((a, b) => {
        // First, sort by locked status (unlocked items first)
        if (a.isLocked !== b.isLocked) {
          return a.isLocked ? 1 : -1;
        }
        
        // Then sort alphabetically within each group
        const nameA = a.name || a.activity || '';
        const nameB = b.name || b.activity || '';
        return nameA.localeCompare(nameB);
      });
      
      // Sort in alphabetical order for isLocked true activities
      allActivitiesData.sort((a, b) => {
        if (a.isLocked && b.isLocked) {
          return a.name.localeCompare(b.name);
        }
        return 0;
      });

      this.setState({ activities: allActivitiesData });
    } catch (error) {
      // Handle error if needed
      console.error("Error fetching activity permissions:", error);
    }
  }
  generateListItems = (buttonText, action, icon, bg) => {
    return this.state.activities.length !== 0 ? (
      <CustomDropdown
        customId={buttonText.replace(/ /g, "_")}
        caret={false}
        noLiPadding
        hoverColor="dark"
        dropPlacement={"bottom-end"}
        buttonText={
          <Button
            className={`${this.props.isIcon ? bg : "outline_btn_new "}`}
            type="button"
            style={{
              margin: 0,
            }}
          >
            {this.props.isIcon && icon} {buttonText}
          </Button>
        }
        buttonProps={{
          color: "transparent",
        }}
        dropdownList={this.generateDropdownItems(action)}
      />
    ) : (
      <></>
    );
  };

  generateDropdownItems = (action) => {
    return this.state.activities.map((item, index) => (
      <React.Fragment key={index}>
        <Button
          className={`${this.props.classes.dropdownLink} ${item.isLocked ? 'dropdown-item-locked' : ''}`}
          data-locked={item.isLocked ? 'true' : 'false'}
          onClick={(e) => {
            e.preventDefault();

            if(item.isLocked){
              showLockUpPopup({
                type: 'download',
                activity: item.activity || item.label || 'Template Download'
              })
              return; // Prevent action if the item is locked
            }

            item.activity.toLowerCase() === "business travel" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "employee travel" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "energy-captive power" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "fuel consumption" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "general details" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "energy-grid" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "waste data" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "upstream transport" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "downstream transport" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "production details" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "buyer share" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "material procurement" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "water" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "wastewater generation" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "water withdrawal" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "water consumption" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "waste water treatment" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "fugitive details" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() ===
              "governance and board composition" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "health and safety" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "human resources" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "csr" &&
              window.open(item.downloadLink, "_parent");
            item.activity.toLowerCase() === "grievances" &&
              window.open(item.downloadLink, "_parent");
          }}
        >
          <span>{item.activityHeader}</span>
          <span> 
            { item && item.isLocked ? <Lock /> : null } 
          </span>
        </Button>
        {index !== this.state.activities.length - 1 && (
          <Divider
            style={{
              backgroundColor: "#e3e3e3",
              marginLeft: "13px",
              height: 1.5,
            }}
            variant="middle"
          />
        )}
      </React.Fragment>
    ));
  };

  render() {
    return (
      <>
        {this.generateListItems(
          "Download Template",
          "download",
          <img src={DownloadWhite} />,
          "outline_btn_new"
        )}
      </>
    );
  }
}
export default withStyles(navbarsStyle)(BulkUploadBtnDownloadTemplateDropdown);
